<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >{{$t('i18n.fota_update')}}</el-breadcrumb-item>
      <el-breadcrumb-item>
          <span v-on:click="back" size='mini'>{{$t('i18n.version_mange')}}</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('i18n.version_history')}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="app-container">
      <el-card class="filter-container" shadow="never">
        <span>{{ $t('i18n.column.project') }}: </span> <span> {{projectName}}  <span>{{ $t('i18n.column.versionNo_update') }}:</span> {{updateVersionNo}}</span>
      <div style="margin-top: 15px">
       
      </div>
    </el-card>
    </div>
  
     <div class="table-container">
        <!-- table表格区域 -->
        <el-table :data="versionDetailList" border stripe>
          <!-- <el-table-column type="index" prop="id"></el-table-column> -->
          <el-table-column :label="$t('i18n.column.version_id')" prop="id" width="100px" ></el-table-column>
          <el-table-column :label="$t('i18n.column.source_versionNo')" prop="oldVersionNo" width="250px" ></el-table-column>
          <el-table-column :label="$t('i18n.column.file_name')" prop="fileName" width="240px" ></el-table-column>
          <el-table-column :label="$t('i18n.column.file_size')" prop="fileSize" width="120px" ></el-table-column>
          <el-table-column :label="$t('i18n.column.upload_update_file')" width="120px">
            <template slot-scope="scope">
              <div>
                    <el-button type="primary"  icon="el-icon-upload el-icon--right" round @click="handleUpLoadBigFile(scope.row)" size='mini' >{{ $t('i18n.upload')}}</el-button>
                </div>
            </template>
          </el-table-column>
           <el-table-column  width="100px" :label="$t('i18n.download')" prop="downloadUrl">
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.downloadUrl!=null && scope.row.downloadUrl.length>1 " :href="scope.row.downloadUrl" :underline="false" style="margin-left:15px">
                            <span>{{$t('i18n.download')}}</span>
                        </el-link>
                    </template>
                </el-table-column>
           <el-table-column :label="$t('i18n.column.file_sync_status')" prop="syncMsg"  width="190px" ></el-table-column>
          <el-table-column :label="$t('i18n.column.update_strategy')" prop="strategy"  width="130px" >
              <template slot-scope="scope" >
                    <el-button  :disabled="scope.row.status===1||scope.row.status===0" type="text" size="mini"  @click="versionStrategy(scope.row)"> {{ $t('i18n.custom_config')}}</el-button>
              </template>
          </el-table-column>
          <el-table-column :label="$t('i18n.column.current_status')"  width="130px" prop="status" >
               <template slot-scope="scope" >
                 <span>{{computeStatus(scope.row.status)}}</span>
              </template>
          </el-table-column>
          <el-table-column :label="$t('i18n.column.release_time')" prop="releaseTime"  width="190px" ></el-table-column>
          <el-table-column :label="$t('i18n.column.is_enabled')" prop="useFlag" width="110px" > 
            <template slot-scope="scope">
              <el-switch v-model="scope.row.useFlag" :active-value="1" :inactive-value="0" @change="handleUpdateUseFlag(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column :label="$t('i18n.column.operator')" >
            <template slot-scope="scope">
              <el-button  v-if="scope.row.status===1" size="mini" type="info" round icon="el-icon-loading" disabled>{{ $t('i18n.column.wait_upload') }}</el-button>
              <el-button  v-if="scope.row.status===2" size="mini" type="success" round @click="handleUpdateVersioStatus(scope.row,4)">{{ $t('i18n.column.test_pass') }}</el-button>
              <el-button  v-if="scope.row.status===2" size="mini" type="warning" round  @click="handleUpdateVersioStatus(scope.row,3)">{{ $t('i18n.column.test_not_pass') }}</el-button>
              <el-button  v-if="scope.row.status===3" size="mini" type="warning" round  disabled >{{ $t('i18n.column.test_not_pass') }} </el-button>
              <el-button  v-if="scope.row.status===4" size="mini" type="danger" round  @click="handleUpdateVersioStatus(scope.row,5)">{{ $t('i18n.column.publish') }} </el-button>
              <el-button  v-if="scope.row.status===5" size="mini" type="danger" round @click="handleUpdateVersioStatus(scope.row,2)">{{ $t('i18n.column.cancel_publish') }} </el-button>
            </template>
          </el-table-column>
        </el-table>
     </div>
     <div class="paginnation-container">
        <!-- 分页区域 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNo" :page-sizes="[5, 10, 15, 20]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize" background>
        </el-pagination>
     </div>


    <div class="config-container">
      <el-dialog :title="$t('i18n.column.version_custom_strategy')" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
        <!-- 内容主体区域 -->
        <el-form :model="addStrategyForm"  ref="addFormRef" label-width="70px">
          
          <el-form-item :label="$t('i18n.column.current_versionNo')"  prop="currentVersionNo" label-width="125px" >
            {{addStrategyForm.currentVersionNo}}
          </el-form-item>
           <el-form-item :label="$t('i18n.column.target_versionNo')" prop="updateVersionNo" label-width="120px" >
             {{addStrategyForm.updateVersionNo}}
          </el-form-item>
          <el-form-item :label="$t('i18n.column.update_package_name')" prop="fileName" label-width="120px"  >
            {{addStrategyForm.fileName}}
          </el-form-item>
          <el-form-item :label="$t('i18n.column.update_package_size')" prop="fileSize" label-width="120px">
            {{addStrategyForm.fileSize}}
          </el-form-item>
          <el-form-item :label="$t('i18n.column.new_version_tip')" prop="updateTips" label-width="120px">
              <template>
                  <el-radio-group v-model="addStrategyForm.updateTips">
                    <el-radio :label="1">{{$t('i18n.column.no_tip')}}</el-radio>
                    <el-radio :label="2">{{$t('i18n.column.dialog')}}</el-radio>
                    <el-radio :label="3">{{$t('i18n.column.notice_board')}}</el-radio>
                  </el-radio-group>
              </template>
          </el-form-item>
          <el-form-item :label="$t('i18n.column.install_tip')" prop="installTips" label-width="120px">
            <template>
                  <el-radio-group v-model="addStrategyForm.installTips">
                    <el-radio :label="1">{{$t('i18n.column.no_tip')}}</el-radio>
                    <el-radio :label="2">{{$t('i18n.column.notice_board')}}</el-radio>
                  </el-radio-group>
              </template>
          </el-form-item>
          <el-form-item :label="$t('i18n.column.auto_download')" prop="autoDownloadFlag" label-width="120px">
              <template>
                  <el-radio-group v-model="addStrategyForm.autoDownloadFlag">
                      <el-radio :label="1">{{$t('i18n.column.base_client')}}</el-radio>
                          <el-radio :label="2">{{$t('i18n.no')}}</el-radio>
                    <el-radio :label="3">{{$t('i18n.column.yes_only_wifi')}}</el-radio>
                    <el-radio :label="4">{{$t('i18n.column.yes_any_network')}}</el-radio>
                  </el-radio-group>
              </template>
          </el-form-item>
          <el-form-item :label="$t('i18n.column.auto_install')" prop="autoUpdateFlag" label-width="120px">
             <template>
                  <el-radio-group v-model="addStrategyForm.autoUpdateFlag ">
                    <el-radio :label="0">{{$t('i18n.no')}}</el-radio>
                    <el-radio :label="1">{{$t('i18n.yes')}}</el-radio>
                  </el-radio-group>
              </template>
          </el-form-item>


          <el-form-item  v-if="addStrategyForm.autoUpdateFlag==1" :label="$t('i18n.column.install_time_period')" prop="autoUpdateStartTime" label-width="120px">
             <template>
                  <span >{{$t('i18n.column.start_time')}}</span>
                    <el-select style="margin-left:10px" v-model="addStrategyForm.autoUpdateStartTime" placeholder="0">
                        <el-option  v-for="item in options"  :key="item.value"  :label="item.label"  :value="item.value">
                        </el-option>
                    </el-select>
                    <span style="margin-left:10px">{{$t('i18n.column.end_time')}}</span>
                    <el-select style="margin-left:10px" v-model="addStrategyForm.autoUpdateEndTime" placeholder="24">
                        <el-option  v-for="item in options"  :key="item.value"  :label="item.label"  :value="item.value">
                        </el-option>
                    </el-select>
              </template>
          </el-form-item>

          <el-form-item :label="$t('i18n.column.update_success_tip')" prop="successTipsFlag" label-width="135px">
            <template>
                  <el-radio-group v-model="addStrategyForm.successTipsFlag ">
                    <el-radio :label="0">{{$t('i18n.no')}}</el-radio>
                    <el-radio :label="1">{{$t('i18n.yes')}}</el-radio>
                 
                  </el-radio-group>
              </template>
          </el-form-item>
          <el-form-item :label="$t('i18n.column.update_battery_level')" prop="updatePowerNeed" label-width="135px">
            <template>
                  <div class="block">
                    <el-slider  v-model="addStrategyForm.updatePowerNeed"  :step="5"  show-stops>
                    </el-slider>
                </div>
              </template>
          </el-form-item>
          <el-form-item :label="$t('i18n.column.is_update_only_imei')" prop="updateImeiFlag" label-width="135px">
             <template>
                  <el-radio-group v-model="addStrategyForm.updateImeiFlag ">
                    <el-radio :label="0">{{$t('i18n.no')}}</el-radio>
                    <el-radio :label="1">{{$t('i18n.column.yes_white_list')}}</el-radio>
                    <el-radio :label="2">{{$t('i18n.column.yes_black_list')}}</el-radio>
                  </el-radio-group>
                <el-button v-if="addStrategyForm.updateImeiFlag!=0"  style="margin-left:15px;" type="text" @click="getVersionDetailImeiList()">{{$t('i18n.column.import_or_query_imei')}}</el-button>
              </template>
          </el-form-item>
        </el-form>
        <!-- 底部区域 -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">{{$t('i18n.cancel')}}</el-button>
          <el-button type="primary"  :style="{ display: showConfirm}" @click="configStrategy">{{$t('i18n.confirm')}}</el-button>
        </span>
      </el-dialog>
      <div >

       <!-- 批量导指定项目IMEI的对话框 -->
            <el-dialog   :title="$t('i18n.batch_import_imei')"    :visible.sync="importDialogVisible"     width="50%"     @close="importDialogClose" >
                <el-form :model="importForm" :rules="importFormRules" ref="importFormRef" label-width="70px">
                    <el-upload  class="upload-border-none"    ref="upload" action="/api/version/excelImportByBlackAndVersionDetailId" :headers="{'sessionKey':sessionKey}" :data="importForm" :limit="1"  :before-upload="handleBefore" 
                        :on-success="handleSuccess" accept=".xls,xlsx"   :auto-upload="false" :file-list="fileList" >
                            <el-button   size="small"  type="primary">{{$t('i18n.choose_file')}}</el-button>
                    </el-upload>
                    <el-form-item :label="$t('i18n.choose_type')" prop="blackFlag" label-width="120px">
                        <template> 
                            <el-radio-group v-model="importForm.blackFlag ">
                                <el-radio :label="0">{{$t('i18n.column.white_list')}}</el-radio>
                                <el-radio :label="1">{{$t('i18n.column.black_list')}}</el-radio>
                            </el-radio-group>
                        </template>
                    </el-form-item>
                </el-form>
                <!-- 底部区域 -->
                <span slot="footer" class="dialog-footer">
                    <el-button @click="importDialogVisible = false">{{$t('i18n.cancel')}}</el-button>
                    <el-button type="primary" @click="importImeiByProject">{{$t('i18n.confirm')}}</el-button>
                </span>
            </el-dialog>

        <el-drawer  :visible.sync="imeiDrawVisible"  direction="rtl"  size="50%">
             <el-card class="filter-container" shadow="never">
                <div>
                    <el-row :gutter="20">
                            <el-col :span="8">
                              <el-input :placeholder="$t('i18n.column.please_input_content')" v-model="importForm.imei" clearable @keyup.enter.native="getVersionDetailImeiList" @clear="getVersionDetailImeiList">
                                  <el-button slot="append" icon="el-icon-search" @click="getVersionDetailImeiList"></el-button>
                              </el-input>
                            </el-col>
                            <el-col :span="4"> 
                               <el-button     type="primary"      @click="importDialogVisible=true"   >{{$t('i18n.batch_import_imei')}}</el-button>
                            </el-col>
                        </el-row>
                </div>
            </el-card>
          <el-table :data="versionDetailImeiList">
                <el-table-column label="IMEI" prop="imei"></el-table-column>
                <el-table-column :label="$t('i18n.column.update_time')" prop="updateTime"></el-table-column>
                <el-table-column :label="$t('i18n.column.is_black_list')" prop="blackFlag"  > 
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.blackFlag" :active-value="1" :inactive-value="0" @change="handleBlack(scope.row)"></el-switch>
                    </template>
                </el-table-column>
          </el-table>

            <div class="paginnation2-container">
                <!-- 分页区域 -->
                <el-pagination @size-change="handleSizeChangeVersionImei" @current-change="handleCurrentChangeVersionImei" :current-page="importForm.pageNo" :page-sizes="[5, 10, 15]" :page-size="importForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize" background>
                </el-pagination>
            </div>

        </el-drawer>
      </div>
    </div>
  </div>
</template>

<script>
import {updateVersionDetailStatus,updateVersionDetail} from '@/api/versionDetail'
import {getVersionStrategyByVersionDetailId,updateVersionDetailStrategy,resetBlackByVersionDetailIdAndImei} from '@/api/versionDetailStrategy'
const defaultListQuery = {
        pageNo: 1,
        pageSize: 15
  }

export default {
  data() {
    return {
      // 查询参数对象
      // 项目列表
      updateVersionNo:'',
      projectName:'',
      versionDetailList: [],
      versionDetailImeiList: [],
      // 总数据条数
      totalSize: 0,
      queryInfo: Object.assign({}, defaultListQuery),
      // 控制添加项目对话框的显示与隐藏
      addDialogVisible: false,
      imeiDrawVisible: false,
      importDialogVisible: false,
      showConfirm:'',
      // 添加的表单数据
      addStrategyForm: {
        "id": null,
        "detailVersionId": null,
        "versionId": null,
        "updateTips": null,
        "installTips": null,
        "updateRegionalFlag": null,
        "updateRegional": null,
        "autoDownloadFlag": null,
        "autoUpdateFlag": null,
        "updatePowerNeed": null,
        "successTipsFlag": null,
        "updateImeiFlag": null,
        currentVersionNo:null,
        updateVersionNo:null,
        fileName:null,
        fileSize:null,
        autoUpdateStartTime: 0,
        autoUpdateEndTime: 24,
      },
      importForm: {
          versionDetailId: '',
          blackFlag:'',
          imei:'',
          pageNo: 1,
          pageSize: 10
      },
      operators:[{
          value: 'other',
          label: 'other'
        },{
          value: 'CMCC',
          label: 'CMCC'
        },{
          value: 'CU',
          label: 'CU'
        },{
          value: 'BIOS',
          label: 'BIOS'
        },{
          value: 'EC',
          label: 'EC'
        }],
         languages:[{
          value: 'zh-CN',
          label: '中文'
        },{
          value: 'en-US',
          label: '英文'
        },{
          value: 'ja-JP',
          label: '日语'
        }],
        updateVersionDetail:{
          detailId:null,
          useFlag:null,
          status:null,
          fileName:null
        },
        dataObj: {
        
        },
        ossUploadUrl:'api/aliyun/oss/upload',
        // ossUploadUrl:'/aliyun/oss/uploadToLocal',
        maxCount:1,
       
        //plupload文件上传
          server_config: this.global.server_config,
        up: {},
        files:[],
        tableData: [],
        uploading: false,
         options: [{
          value: '0',
          label: '0'
        }, {
          value: '1',
          label: '1'
        },{
          value: '2',
          label: '2'
        }, {
          value: '3',
          label: '3'
        }, {
          value: '4',
          label: '4'
        }, {
          value: '5',
          label: '5'
        }, {
          value: '6',
          label: '6'
        }, {
          value: '7',
          label: '7'
        }, {
          value: '8',
          label: '8'
        }, {
          value: '9',
          label: '9'
        }, {
          value: '10',
          label: '10'
        }, {
          value: '11',
          label: '11'
        }, {
          value: '12',
          label: '12'
        }, {
          value: '13',
          label: '13'
        }, {
          value: '14',
          label: '14'
        }, {
          value: '15',
          label: '15'
        }, {
          value: '16',
          label: '16'
        }, {
          value: '17',
          label: '17'
        }, {
          value: '18',
          label: '18'
        }, {
          value: '19',
          label: '19'
        }, {
          value: '20',
          label: '20'
        }, {
          value: '21',
          label: '21'
        }, {
          value: '22',
          label: '22'
        }, {
          value: '23',
          label: '23'
        }, {
          value: '24',
          label: '24'
        }],

    // 导入imei表单的验证规则对象
      importFormRules: {
          blackFlag: [{ required: true, message: this.$t('i18n.validate.white_black_list_need'), trigger: 'blur' }],
      },
      fileList: [],
      
    }
  },
  created() {
    this.getParam()
    this.getVersionDetailList()
    this.sessionKey=localStorage.getItem("sessionKey")
  },

  methods: {
      
      getParam(){
        const param=this.$route.query;
        this.queryInfo.versionId=param.updateVersionId
        this.updateVersionNo=param.updateVersionNo
        this.projectName=param.projectName
        // console.log("版本详情跳转接受的参数",param)
      },

     computeStatus(status){
        if(status=='0'){
            return this.$t('i18n.column.init_version')
        }else if(status=='1'){
            return this.$t('i18n.column.wait_upload')
            
        }else if(status=='2'){
            return this.$t('i18n.column.wait_test')
            
        }else if(status=='3'){
            return this.$t('i18n.column.test_not_pass')
        }else if(status=='4'){
            return this.$t('i18n.column.wait_publish')
        }else if(status=='5'){
            return this.$t('i18n.column.published')
        }else if(status=='6'){
            return this.$t('i18n.column.published')
        }
        return this.$t('i18n.column.wait_upload');
    },
  //修改状态
 async handleUpdateVersioStatus(row,status){
    this.updateVersionDetail.detailId=row.id
    this.updateVersionDetail.status=status
      const {data:res}=  await updateVersionDetailStatus(this.updateVersionDetail)
      if(res.code!=0){
        return this.$message.error(res.msg)
      }
      this.getVersionDetailList()
  },
   async handleUpdateUseFlag(row){
      console.log('***updateVersion****',row)
      this.updateVersionDetail.detailId=row.id
      this.updateVersionDetail.useFlag=row.useFlag
      this.updateVersionDetail.status=row.status
      const {data:res}=  await updateVersionDetailStatus(this.updateVersionDetail)
      if(res.code!=0){
        if(row.useFlag===0){
          row.useFlag=1
        }else{
          row.useFlag=0
        }
        return this.$message.error(res.msg)
      }
    },
    getVersionDetailList() {
        this.$http.get('/version/queryVersionDetailPageByVersionId',{
                    params: this.queryInfo
                }).then(res => {
                    // console.log('返回',res.data)
                    res=res.data
                    if(res.code!=0){
                        return this.$message(res.msg)
                    }
                    this.versionDetailList=res.data.list;
                    this.totalSize=res.data.totalSize
                    // console.log('返回list',this.versionDetailList)
                });
     
    },

    getVersionDetailImeiList() {
      this.imeiDrawVisible=true
      this.$http.get('/version/queryVersionImeiDetailPage',{
                    params: this.importForm
                }).then(res => {
                    // console.log('返回',res.data)
                    res=res.data
                    if(res.code!=0){
                        return this.$message(res.msg)
                    }
                    this.versionDetailImeiList=res.data.list;
                    this.totalSize=res.data.totalSize
                    // console.log('返回list',this.versionDetailList)
                });
     
    },
    initImportFormData(){
      this.importForm.imei=''
       this.importForm.blackFlag=''
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getVersionDetailList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNo = newPage
      this.getVersionDetailList()
    },


  
 
    handleSizeChangeVersionImei(newSize) {
      this.importForm.pageSize = newSize
      this.getVersionDetailImeiList()
    },
    handleCurrentChangeVersionImei(newPage) {
      this.importForm.pageNo = newPage
      this.getVersionDetailImeiList()
    },

  
  handleRemove(file, fileList) {
  },
  handlePreview(file) {
    this.dialogVisible = true;
  },
   back() {
            this.$router.go(-1); //返回上一层
        },
      //上传文件成功后回调
    async handleUploadSuccess(res, file) {
      console.log('--res---',res)
      console.log("文件大小",file.size)
      console.log("文件类型",file.type)
      if(res.code!=0){
        return this.$message.error(res.msg)
      }
      //上传成功后更新上传数据
      this.updateVersionDetail.downloadUrl=res.data
      this.updateVersionDetail.fileName=file.name
      var num=file.size/ 1024 / 1024
      var flag=false;
      if(num<0.01){
        flag=true
        num=file.size/ 1024
      }
      this.updateVersionDetail.fileSize=num.toFixed(2)+""+(flag==true?"Kb":"M")
      const {data:res2} =  await updateVersionDetail(this.updateVersionDetail)
      this.getVersionDetailList()
    },  
    
    // 监听添加项目对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    },
    //获取定制配置信息
    async versionStrategy(row){
      const{data:res}= await getVersionStrategyByVersionDetailId(row.id)
      // console.log('策略返回',res)
      if(res.code!=0){
        return this.$message.error(res.msg)
      }
      Object.assign(this.addStrategyForm,res.data)
      this.addDialogVisible=true
      this.importForm.versionDetailId=row.id
      if(row.status===3||row.status===5){//控制对话框确定按钮的显示、隐藏
        this.showConfirm='none'
      }else{
         this.showConfirm=''
      }
      console.log("策略详细信息",this.addStrategyForm)
    },

     //获取定制配置信息
    async versionStrategy(row){
      const{data:res}= await getVersionStrategyByVersionDetailId(row.id)
      // console.log('策略返回',res)
      if(res.code!=0){
        return this.$message.error(res.msg)
      }
      Object.assign(this.addStrategyForm,res.data)
      this.addDialogVisible=true
      this.importForm.versionDetailId=row.id
      if(row.status===3||row.status===5){//控制对话框确定按钮的显示、隐藏
        this.showConfirm='none'
      }else{
         this.showConfirm=''
      }
      console.log("策略详细信息",this.addStrategyForm)
    },

         //获取定制配置信息
    async versionDetailImeiQuery(){
      const{data:res}= await getVersionStrategyByVersionDetailId(row.id)
      // console.log('策略返回',res)
      if(res.code!=0){
        return this.$message.error(res.msg)
      }
      Object.assign(this.addStrategyForm,res.data)
      this.addDialogVisible=true
      this.importForm.versionDetailId=row.id
      if(row.status===3||row.status===5){//控制对话框确定按钮的显示、隐藏
        this.showConfirm='none'
      }else{
         this.showConfirm=''
      }
      console.log("策略详细信息",this.addStrategyForm)
    },

    // 更新定制策略
    configStrategy() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        // 可以发起添加项目的网络请求
        const { data: res } = await updateVersionDetailStrategy(this.addStrategyForm)
        if (res.code !== 0) {
          this.$message.error(res.msg)
        }
        // 隐藏添加项目的对话框
        this.addDialogVisible = false
      })
    },

    //文件上传
    handleUpLoadBigFile(param) {
   
            this.$router.push({path:'/versionStopUpload',
            query:{
                currentVersionNo:param.oldVersionNo,
                currentVersionId:param.id,
                updateVersionNo:this.updateVersionNo,
                projectName:this.projectName
            }
            });
               
    },
    

          // 点击按钮，导入指定项目IMEI
    importImeiByProject() {
          this.$refs.importFormRef.validate(async valid => {
                if (!valid) return;
                this.$refs.upload.submit();
            });
           
      },
      // 上传前的回调函数
  　　handleBefore(file) {
  　　　 
  　　},
     // 监听添加IEMI对话框的关闭事件
        importDialogClose() {
            this.$refs.importFormRef.resetFields();
            this.fileList=[]
        },
      // 上传成功回调
  　　handleSuccess(res) {
      this.$refs.upload.clearFiles()
      if(res.code==0){
          this.importDialogVisible = false;
          this.$message.success(res.msg);
          this.getVersionDetailImeiList()
      }else{
          this.$message.error(res.ms);
      }
  　},
        /**重置指定版本设置黑白名单 1启用 0停用 */
      async handleBlack(row){
                const {data:res}=  await resetBlackByVersionDetailIdAndImei(row.versionDetailId,row.imei,row.blackFlag)
                if(res.code!=0){
                    if(row.blackFlag===0){
                    row.blackFlag=1
                    }else{
                    row.blackFlag=0
                    }
                    return this.$message.error(res.msg)
                }
       },

  }
}
</script>

<style  scoped>
    .el-pagination {
         text-align: right; 
    }
    /* .paginnation-container {
        position: fixed;
        left: 40%;
        bottom: 0%
    } */
</style>